export default "__VITE_ASSET__BTy3Bf1M__"